import { render, staticRenderFns } from "./Mouse.vue?vue&type=template&id=4d819376&scoped=true"
import script from "./Mouse.vue?vue&type=script&lang=js"
export * from "./Mouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d819376",
  null
  
)

export default component.exports